import { InputAdornment, InputBase, InputBaseProps } from '@material-ui/core';
import { Theme } from '@emotion/react';
import {
  endAdornmentStyles,
  inputBase,
  startAdornmentStyles,
} from 'omakase/FormControls/formControlInputCssDefs';
import FormControlInputCore, {
  FormControlInputCoreProps,
  FormControlInputVariantProp,
  getHelperTextId,
} from 'omakase/FormControls/FormControlInputCore';
import React from 'react';

export type TextFieldVariant = 'basic' | 'inverse';

export interface TextFieldOwnProps {
  /**
   * End adornment for the component
   */
  endAdornment?: React.ReactNode;
  /**
   * Start adornment for the component
   */
  startAdornment?: React.ReactNode;
}

export type TextFieldProps = TextFieldOwnProps &
  FormControlInputCoreProps &
  FormControlInputVariantProp &
  InputBaseProps;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TextField = React.forwardRef<any, TextFieldProps>(
  (
    {
      children,
      disabled,
      error,
      warn,
      valid,
      label,
      endAdornment,
      startAdornment,
      labelAdornment,
      helperText,
      variant = 'basic',
      placeholder,
      id,
      ...rest
    },
    ref: React.Ref<HTMLDivElement> | undefined
  ) => {
    return (
      <FormControlInputCore
        disabled={disabled}
        error={error}
        label={label}
        labelAdornment={labelAdornment}
        helperText={helperText}
        placeholder={placeholder}
        warn={warn}
        valid={valid}
        id={id}
        ref={ref}
      >
        <InputBase
          css={(theme: Theme) => inputBase(theme, variant)}
          startAdornment={
            startAdornment && (
              <InputAdornment css={startAdornmentStyles} position="start">
                {startAdornment}
              </InputAdornment>
            )
          }
          endAdornment={
            endAdornment && (
              <InputAdornment css={endAdornmentStyles} position="end">
                {endAdornment}
              </InputAdornment>
            )
          }
          aria-describedby={helperText ? getHelperTextId(id) : undefined}
          id={id}
          placeholder={placeholder}
          {...rest}
        />
      </FormControlInputCore>
    );
  }
);

export default TextField;
